import React from "react";

export default function Phonetics(props) {
  return (
    <div className="phonetics row phonetic-row">
      <div className="phonetic-text col-3">{props.phonetics.text}</div>
      {getAudio(props.phonetics.audio)}
    </div>
  );
  function getAudio(audio) {
    if (audio) {
      return (
        <div className="phonetic-audio col-1">
          <a href={audio} target="_blank" rel="noreferrer">
            Listen
          </a>
        </div>
      );
    } else {
      return <div className="col-1"></div>;
    }
  }
}
